import React, { useRef, useEffect, useState } from "react";
import { Dialog, DialogActions, DialogContent } from "@mui/material";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { Alert, Button, DateField, Stack } from "@curves/ui-base";
import { useEmployeeApi } from "@apis/useEmployeeApi";
import useEmployeeScheduleApi from "@apis/useEmployeeScheduleApi";
import useAppSystemApi from "@apis/useAppSystemApi";
import useMessageDialog from "@util/hook/useMessageDialog";
import { refIsRequiredError } from "@util/utils";
import Tablenization from "@icoach/components/Tablenization";
import { parseDate } from "@util/moment";

const DutyMessageBox = props => {
	const { scheduleList: list } = props;
	const label = [
		{
			cellKey: "dutyDate",
			headerLabel: "排班日期",
			formatCell: cellValue => {
				return parseDate(cellValue, "YYYY-MM-DD");
			},
		},
		{
			cellKey: "dutyTime",
			headerLabel: "排班時間",
		},
		{
			cellKey: "dutyDescription",
			headerLabel: "預約類型",
		},
	];

	return (
		<React.Fragment>
			<Tablenization cardProps={{ className: "theme-gray overview" }}>
				<Tablenization.TableRowHeader headerRow={label} />
				<Tablenization.TableRowBody headerRow={label} rowsData={list} />
			</Tablenization>
			<Alert className="alert-justify-content-start mt-4" variant="filled" severity="info" color="info">
				將於設定日期+1日，移除所有排班擔當
			</Alert>
		</React.Fragment>
	);
};

const EmployeeResignDialog = React.forwardRef((props, ref) => {
	const { sourceData, onClose: onCloseProps, open: openProps, refresh } = props;
	if (!openProps) return;
	const [taipeiTime, setTaipeiTime] = useState(null);
	const { putEmployeesStatusApi } = useEmployeeApi();
	const { getEmployeeScheduleDutyListApi } = useEmployeeScheduleApi();
	const setMessageDialog = useMessageDialog();
	const { getTaipeiTimeApi } = useAppSystemApi();
	const { employeeID, employeeStatus } = sourceData;
	const resignDateRef = useRef(null);

	const getParams = () => {
		return {
			employeeID,
			employeeStatus,
			resignDate: resignDateRef.current.getResult(),
		};
	};

	const handleOnclick = () => {
		if (!refIsRequiredError(resignDateRef)) {
			const params = getParams();
			editEmployeeStatusApi(params);
		}
	};

	const editEmployeeStatusApi = async params => {
		const resp = await putEmployeesStatusApi(params);
		if (resp) {
			// 打是否有預約單的API
			const scheduleList = await getEmployeeScheduleDutyListApi({ employeeID: params.employeeID, resignDate: params.resignDate });
			setMessageDialog({
				open: true,
				title: "排班表",
				dialogPaperProps: { className: "wx-50rem" },
				MsgComp: () => <DutyMessageBox scheduleList={scheduleList} />,
			});
			refresh();
			onCloseProps();
		}
	};

	useEffect(
		() => {
			const fetchTime = async () => {
				const resp = await getTaipeiTimeApi();
				if (resp) setTaipeiTime(parseDate(resp.dateTime));
			};
			fetchTime();
		},
		// eslint-disable-next-line
		[]
	);

	return (
		<Dialog open={openProps} PaperProps={{ className: "wx-40rem" }} fullWidth>
			<GradientColorHeader onClose={onCloseProps}>{"設定離職資訊"}</GradientColorHeader>
			<DialogContent className="pt-4 px-5">
				<Stack justifyContent="center" spacing="2" direction="column">
					<DateField ref={resignDateRef} minDate={taipeiTime} label="填寫離職日期" placeholder="請選擇離職日期（生效日）" fullWidth required />
					<Alert className="alert-justify-content-start" variant="filled" color="gray" severity="info">
						離職狀態將於設定日期當天自動生效，設定後可於列表中撤銷
					</Alert>
				</Stack>
			</DialogContent>
			<DialogActions>
				<Button variant="contained" onClick={handleOnclick}>
					儲存離職資訊
				</Button>
			</DialogActions>
		</Dialog>
	);
});

export default EmployeeResignDialog;
